import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd1a27ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "config-form" }
const _hoisted_2 = { class: "config-form__space" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "config-form__avatar__upload-mask" }, null, -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "config-form__avatar__upload"
}
const _hoisted_6 = { class: "config-form__input" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("创建空间")

import { generateImage, generateRandomHex } from '@/utils'
import { refDebounced } from '@vueuse/core'
import {
  FormInst,
  NForm,
  NFormItem,
  NInput,
  NSpace,
  NButton,
  FormRules,
  FormItemRule
} from 'naive-ui'
import { computed, ref, reactive, toRefs, onMounted } from 'vue'
import Icon from '@teams/common/components/icon'
import ConfigMembers from './configMembers/index.vue'
import { useAppDialog } from '@/components/appDialog'
import { useUserStore } from '@/store/user'
import {
  getGroupTemplateDetail,
  createTemplateGroup,
  updateGroupAvatar
} from '@teams/common/api'
import type { GetGroupTemplateDetailResponse } from '@teams/common/api/types'
import { extractAvatarTitleByGroupName, processNavs } from './utils'
import handleResponseError from '@teams/common/hooks/useResponseError'

interface IFromData {
  name: string
  description: string
  isPrivateTeam: boolean
  isSaveTemplate: boolean
}

interface Emits {
  (e: 'close'): () => void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'configForm',
  props: {
    templateId: null,
    avatar: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): () => void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  templateId: number
  avatar?: string
}

_useCssVars(_ctx => ({
  "35ae78a4": (avatarBackgroundColor)
}))


const { templateId, avatar } = toRefs(props)

const dialog = useAppDialog()
const userStore = useUserStore()

const formRef = ref<FormInst | null>(null)
const formValue = reactive<IFromData>({
  name: '',
  description: '',
  isPrivateTeam: false,
  isSaveTemplate: true
})
const nameMaxLength = 15
const descriptionMaxLength = 40
const rules: FormRules = {
  name: [
    {
      required: true,
      validator(rule: FormItemRule, value: string) {
        const reg = /[\\/:*?"<>|]/
        if (!value) {
          return new Error('空间名称不能为空')
        } else if (reg.test(value)) {
          return new Error(`空间名称不能包含非法字符\\/:*?"<>|`)
        } else if (value.length > nameMaxLength) {
          return new Error(`空间名称不得超过${nameMaxLength}个字符`)
        } else {
          return true
        }
      },
      trigger: ['input', 'blur']
    }
  ],
  description: [
    {
      required: true,
      validator(rule: FormItemRule, value: string) {
        if (value.length > descriptionMaxLength) {
          return new Error(`空间描述不得超过${descriptionMaxLength}个字符`)
        } else {
          return true
        }
      },
      trigger: ['input', 'blur']
    }
  ]
}
const createSpaceButtonLoading = ref<boolean>(false)
const template = ref<GetGroupTemplateDetailResponse>()
const groupName = computed(() => formValue.name)
const debouncedGroupName = refDebounced(groupName, 10)
const avatarBackgroundColor = '#' + generateRandomHex()
const generatedAvatar = computed(() => {
  if (!debouncedGroupName.value) {
    return ''
  }
  const base64 = generateImage({
    text: extractAvatarTitleByGroupName(debouncedGroupName.value),
    textColor: '#fff',
    backgroundColor: avatarBackgroundColor,
    font: '64px PingFang SC'
  })
  return base64
})

const displayedAvatar = computed(() => avatar?.value || generatedAvatar.value)
const showUpload = () => {
  dialog.show({
    name: 'SelectAvatar',
    componentProps: {
      onConfirm: (value: string, dialogFunc) => {
        dialogFunc?.back?.({ componentProps: { avatar: value } })
      }
    }
  })
}
const checkContent = computed(() => {
  if (
    formValue.name === '' ||
    formValue.name.length > 15 ||
    formValue.description.length > 40
  ) {
    return true
  } else {
    return false
  }
})
const createGroup = async () => {
  createSpaceButtonLoading.value = true
  try {
    const { data } = await createTemplateGroup(templateId.value, {
      name: formValue.name,
      desc: formValue.description,
      keep_content: formValue.isSaveTemplate,
      navigation: processNavs(template.value?.navigation || []),
      private: formValue.isPrivateTeam,
      // 如没有 workspace，则默认为个人账号，传 0
      company_id: userStore.currentWorkSpace?.workspace || 0
    })
    await updateGroupAvatar({
      data: displayedAvatar.value,
      group_id: data.group_id
    })

    dialog.show({
      component: ConfigMembers,
      showCloseIcon: false,
      replace: true,
      componentProps: {
        groupId: data.group_id,
        roleList: template.value?.role.map(item => {
          return {
            roleId: item.id,
            roleName: item.name,
            roleDesc: item.desc
          }
        })
      },
      footer: false
    })
    createSpaceButtonLoading.value = false
  } catch (e: any) {
    handleResponseError(e)
    createSpaceButtonLoading.value = false
  }
}
const submit = () => {
  formRef.value?.validate(errors => {
    if (!errors) {
      createGroup()
    }
  })
}

const close = () => {
  emit('close')
}

const initTemplate = async (templateId: number) => {
  try {
    const { data } = await getGroupTemplateDetail(templateId)
    formValue.name = data.name
    formValue.description = data.desc
    template.value = data
  } catch (e) {
    handleResponseError(e)
  }
}

onMounted(() => {
  initTemplate(templateId.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NForm), {
      ref_key: "formRef",
      ref: formRef,
      model: formValue,
      "label-placement": "left",
      "label-width": "auto",
      "require-mark-placement": "right-hanging",
      rules: rules,
      "show-require-mark": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "config-form__avatar",
            onClick: showUpload
          }, [
            (_unref(displayedAvatar))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_3,
                  _createElementVNode("img", {
                    src: _unref(displayedAvatar),
                    alt: ""
                  }, null, 8, _hoisted_4)
                ], 64))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createVNode(_unref(Icon), {
                    name: "addAvatar",
                    size: 22
                  })
                ]))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(NFormItem), {
              path: "name",
              label: "空间名称"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  value: formValue.name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formValue.name) = $event)),
                  class: "formInput",
                  onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                  placeholder: "请输入空间名称",
                  clearable: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(NFormItem), {
              path: "description",
              label: "空间描述"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  value: formValue.description,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formValue.description) = $event)),
                  class: "formInput",
                  onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                  placeholder: "请输入空间描述",
                  clearable: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_unref(NSpace), { justify: "end" }, {
      default: _withCtx(() => [
        _createVNode(_unref(NButton), {
          class: "config-form__btn cancelBtn",
          onClick: close
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_unref(NButton), {
          type: "primary",
          class: "config-form__btn",
          onClick: submit,
          disabled: _unref(checkContent),
          loading: createSpaceButtonLoading.value
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ]),
      _: 1
    })
  ]))
}
}

})